// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3e9Ww","label":"styles_label__3KvZN"};